(function () {
  'use strict';

  /**
   * A write-only secret input (EDOCS-627).
   *
   * The server never sends a stored secret back, for any role: the field starts empty, a placeholder says when a
   * value is kept, and saving it blank keeps that value. A SUPERADMIN gets an eye button that reveals the stored
   * value through POST /api/secrets/reveal, which asks for their password and a reason and records the read.
   *
   * <ed-secret-field model="row.value" secret-id="row.id" source="COMMUNICATION_PARAMETER"
   *                  stored="row.secretStored" read-only="vm.readOnly === true"></ed-secret-field>
   */
  angular.module('eDocumentsApp').directive('edSecretField', edSecretField);

  edSecretField.$inject = ['Principal', '$uibModal'];

  function edSecretField(Principal, $uibModal) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        secretId: '<',
        source: '@',
        stored: '<',
        readOnly: '<',
        fieldName: '@',
        // the input's accessible name; the field has no <label> of its own, so without this it is "Credencial"
        fieldLabel: '@',
      },
      templateUrl: 'app/components/secret/secret-field.html',
      link: function (scope) {
        scope.canReveal = false;
        Principal.hasAuthority('ROLE_SUPERADMIN').then(function (result) {
          scope.canReveal = result;
        });
        scope.reveal = function () {
          $uibModal.open({
            templateUrl: 'app/components/secret/secret-reveal.html',
            controller: 'SecretRevealController',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              target: function () {
                return { source: scope.source, id: scope.secretId };
              },
            },
          });
        };
      },
    };
  }
})();
